<template>
  <section :class="$style.root">
    <div :class="$style.content">
      <h2 :class="$style.heading">
        {{ title }}
      </h2>

      <component
        v-if="download"
        :is="download?.data?.attributes?.url ? 'a' : 'div'"
        :href="download?.data?.attributes?.url"
        target="_blank"
      >
        <CoreImageComponent
          :image="coverImage?.data?.attributes"
          :class="$style.image"
        />
      </component>
    </div>
  </section>
</template>

<script setup>
const { locale: currentLocale, locales } = useI18n()

const props = defineProps({
  data: Object
})

const title = computed(() => i18nGetLocalizedString(props?.data))

const download = computed(() => {
  return currentLocale.value === 'en' ? props?.data?.i18n_download_en : props?.data?.i18n_download_al
})

const coverImage = computed(() => {
  return currentLocale.value === 'en' ? props?.data?.i18n_cover_image_en : props?.data?.i18n_cover_image_al
})
</script>

<style module>
.root {
  background-color: var(--color--gray);
}

.content {
  composes: container--default from global;
  padding: var(--unit--vertical) var(--unit--horizontal);

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--unit--vertical);
}

.heading {
  composes: reset-heading font-size-default from global;
  text-align: center;

  text-transform: uppercase;
  margin-bottom: calc(var(--unit--vertical) * 1);
}

.image {
  width: 20rem;
  box-shadow: var(--box-shadow--default);
}
</style>
